<template>
  <div class="nuttrema-widget">
    <!-- <h4 class="nuttrema-widget__sup_title">{{ $t('label.latest') }}</h4> -->
    <Timeline
      class="nuttrema-widget--twitter"
      id="dietcreator"
      :sourceType="'profile'"
      :options="{ tweetLimit: '3' }"
    >
      <nuttrema-loader></nuttrema-loader>
    </Timeline>
  </div>
</template>

<script>
import { Timeline } from 'vue-tweet-embed';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

import AbstractWidget from './abstract-widget';

export default {
  name: 'widget-twitter-latest',
  mixins: [AbstractWidget],
  components: {
    Timeline,
    NuttremaLoader,
  },
};
</script>

<style lang="scss">
@import './abstract-widget';

.nuttrema-widget--twitter {
  min-height: 20em;
  iframe {
    margin-bottom: -0.5em !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ui/widgets/widget-twitter-latest.vue